import { TileLayer, MapContainer, ZoomControl, ScaleControl } from 'react-leaflet';
import { MapEffect, useMap } from './Map.hooks';
import { MapProps } from './Map.interface';
import { Container } from './Map.styles';
import { MIN_ZOOM } from "./utils";

export const Map = ({ children }: MapProps) => {
  const { 
    isMobile
  } = useMap();
  return (
    <Container className="map-container">
      <MapContainer 
        minZoom={MIN_ZOOM}
        bounds={[
          [52.696361078274485, -53.349609375],
          [52.696361078274485, -137.724609375],
          [23.200960808078566, -53.349609375],
          [23.200960808078566, -137.724609375]
        ]}
        style={{
          width: "100%",
          height: "100%"
        }}
        maxBounds={[[-90, -180], [90, 180]]}
        zoomControl={false}
        zoomSnap={isMobile ? 0.1 : 1}
      >
        <TileLayer
          attribution='&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors'
          url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
        />
        {!isMobile && 
          <ZoomControl position="bottomright" />
        }
        <ScaleControl position="bottomleft" />
        {children}
        <MapEffect />
      </MapContainer>
    </Container>
  )
}
